import { useTranslation } from 'react-i18next';
import { Button, Modal } from 'antd';

interface ConfirmCancelModalProps {
  isOpen: boolean;
  reject: () => void;
  confirm: () => void;
}

export const ConfirmCancelModal = ({
  isOpen,
  reject,
  confirm,
}: ConfirmCancelModalProps) => {
  const { t } = useTranslation();

  return (
    <Modal
      title={t('common.confirmCancel.unsavedChanges')}
      open={isOpen}
      maskClosable={false}
      destroyOnHidden
      onCancel={reject}
      footer={
        <>
          <Button onClick={reject}>{t('common.buttons.cancel')}</Button>
          <Button onClick={confirm} danger type="primary">
            {t('common.buttons.confirm')}
          </Button>
        </>
      }
    >
      {t('common.confirmCancel.unsavedChangesConfirm')}
    </Modal>
  );
};
